import { FormPageLayout } from '../layouts';

/**
 * Early Access Program page
 * Sign-up page for EllaFin Early Access Program (ActiveCampaign form 19,
 * see src/content/ac-forms.json and docs/ACTIVE_CAMPAIGN.md).
 * Using FormPageLayout for consistent structure
 *
 * @returns {JSX.Element} Early Access Program page
 */
function EarlyAccessProgram() {
  return (
    <FormPageLayout
      title="EllaFin™ Early Access Program"
      subtitle="AWS and Financial Reporting for Executives"
      formHeading="Join the Early Access Program"
      formFilePath="/forms/ellafin-early-access-form.txt"
      errorMessage="Unable to load sign-up form"
      loadingMessage="Loading sign-up form..."
    />
  );
}

export default EarlyAccessProgram;
